export default "__VITE_ASSET__B_Np8Kph__"